import { render } from "./messageShow.vue?vue&type=template&id=77a46984&scoped=true"
import script from "./messageShow.vue?vue&type=script&lang=js"
export * from "./messageShow.vue?vue&type=script&lang=js"

import "./messageShow.vue?vue&type=style&index=0&id=77a46984&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a46984"]])

export default __exports__